import { supabase } from '../lib/supabaseClient';

const getAuthToken = async () => {
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token;
};

const readError = async (res) => {
  try {
    const body = await res.json();
    return body?.error || body?.message || `Request failed (${res.status})`;
  } catch {
    return `Request failed (${res.status})`;
  }
};

export const authedJson = async (url, options = {}) => {
  const token = await getAuthToken();
  if (!token) throw new Error('Your admin session has expired. Please sign in again.');
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`
    }
  });
  if (!res.ok) throw new Error(await readError(res));
  if (res.status === 204) return null;
  return res.json();
};
